module.exports = __webpack_public_path__ + "img/nt85-08-82-1_1.prt.fa12378d.jpg";